import React, { PureComponent } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import { calculateRemainingTime } from './DRNTimeUtil';
export const withSecondInterval = (WrappedComponent) => {
    return hoistNonReactStatics(class CountdownWrapper extends PureComponent {
        constructor() {
            super(...arguments);
            this.state = {
                expired: false,
                remaining: 0,
            };
            this.timer = null;
            this.checkEndTimestamp = () => {
                const { endTimestamp } = this.props;
                this.setState({ endTimestamp }, this.startTimer);
            };
            this.startTimer = () => {
                this.stopTimer();
                const { endTimestamp } = this.state;
                if (!endTimestamp)
                    return;
                const { finished, remaining } = calculateRemainingTime(endTimestamp);
                if (finished) {
                    this.setState({ expired: true, remaining: 0 });
                    return;
                }
                this.setState({ remaining }, () => {
                    this.timer = setInterval(this.advanceCountdown, 1000);
                });
            };
            this.stopTimer = () => {
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
            };
            this.advanceCountdown = () => {
                const { remaining } = this.state;
                if (remaining < 1) {
                    clearInterval(this.timer);
                    this.timer = null;
                    this.setState({ expired: true });
                    return;
                }
                this.setState({ remaining: remaining - 1 });
            };
        }
        componentDidMount() {
            this.checkEndTimestamp();
        }
        componentWillUnmount() {
            this.stopTimer();
        }
        render() {
            const { endTimestamp, expired, remaining } = this.state;
            const hasExpired = endTimestamp ? expired : this.props.parentExpired;
            return React.createElement(WrappedComponent, Object.assign({}, this.props, { expired: hasExpired, remaining: remaining }));
        }
    }, WrappedComponent);
};
export default withSecondInterval;
